import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=f8213d1c&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=f8213d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8213d1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8213d1c')) {
      api.createRecord('f8213d1c', component.options)
    } else {
      api.reload('f8213d1c', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=f8213d1c&scoped=true&", function () {
      api.rerender('f8213d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/Tag.vue"
export default component.exports